module.exports = {"431229100":"渠阳镇","431229101":"甘棠镇","431229102":"大堡子镇","431229103":"坳上镇","431229104":"新厂镇","431229105":"平茶镇","431229200":"太阳坪乡","431229201":"三锹乡","431229202":"文溪乡","431229203":"寨牙乡","431229206":"藕团乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431229.json
// module id = 1926
// module chunks = 0